import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { getActiveVariant } from '../../helpers.js';
import '@grandvisionhq/utils';
import { useBrandLink } from '../utils/use-brand-link.js';
import Accessories from './Accessories.js';

const AccessoriesContainer = ({ activeSku , addToCartRef , handleConversionEvent , onCTAClick , product , showStickyButton , variant , storesRoute  })=>{
    var ref;
    const { currency , locale  } = useIntl();
    const brandLink = useBrandLink(product);
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const activeVariant = getActiveVariant(product, activeSku);
    var ref1;
    const stockCount = (ref1 = (ref = variant.availability) === null || ref === void 0 ? void 0 : ref.availableQuantity) !== null && ref1 !== void 0 ? ref1 : 0;
    const isOrderable = (variant === null || variant === void 0 ? void 0 : variant.channelAvailability) === 'ONLINE';
    const variants = React.useMemo(()=>[
            product.masterVariant,
            ...product.variants
        ]
    , [
        product.masterVariant,
        product.variants
    ]);
    return /*#__PURE__*/ React.createElement(Accessories, {
        activeSku: activeSku,
        activeVariant: activeVariant,
        addToCartRef: addToCartRef,
        brandLink: brandLink,
        currency: currency,
        handleConversionEvent: handleConversionEvent,
        isMobile: isMobile,
        isSmallScreen: isSmallScreen,
        isOrderable: isOrderable,
        locale: locale,
        onCTAClick: onCTAClick,
        product: product,
        showStickyButton: showStickyButton,
        stockCount: stockCount,
        variant: variant,
        variants: variants,
        storesRoute: storesRoute
    });
};

export { AccessoriesContainer as default };
//# sourceMappingURL=AccessoriesContainer.js.map
